<script>
import BScroll from 'better-scroll'
import Sliding from 'base/sliding/sliding'
import { getScreenSize } from 'common/js/dom'
const TITLE_HEIGHT = 45
const TABLE_HEAD_HEIGHT = 40
const TABLE_COLUMN_WIDTH = 112
const SIZE = getScreenSize()
const ua = navigator.userAgent
const isWechat = /micromessenger/.test(ua.toLowerCase())
const isIos = /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i.test(ua)

export default {
  name: 'ScrollTable',
  components: {
    Sliding
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default () {
        return []
      }
    },
    ageIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    // ios && 微信
    // 跳转产生历史记录后底部会有工具栏
    // 可能会遮罩页面内容
    this.fixIosWechatBar = isIos && isWechat
    return {
      show: false,
      scrollHeight: 0
    }
  },
  computed: {
    dataLenth () {
      const { list } = this
      return ((list[0] && list[0].values) || []).length
    },
    itemWidth () {
      const { screenWidth, list } = this
      const len = list.length
      return (screenWidth - TABLE_COLUMN_WIDTH) / (len > 3 ? 3 : len)
    }
  },
  watch: {
    value: {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            this.initScroll()
          })
        }
      }
    },
    list: function () {
      this.$nextTick(() => {
        this.initScroll()
      })
    }
  },
  created () {
    this.screenWidth = SIZE.width
  },
  methods: {
    detectSlot () {
      this.scrollHeight =
        SIZE.height * 0.9 - TABLE_HEAD_HEIGHT - (this.title ? TITLE_HEIGHT : 0)
      if (!this.$slots) return
      let slotHeight = 0
      for (var slots in this.$slots) {
        for (var slot of this.$slots[slots]) {
          slot.elm && (slotHeight += slot.elm.offsetHeight || 0)
        }
      }
      this.scrollHeight =
        this.scrollHeight - slotHeight + (this.title ? TITLE_HEIGHT : 0)
    },
    initScroll () {
      this.detectSlot()
      if (this.headerScroll && this.bodyScroll) {
        this.headerScroll.refresh()
        this.bodyScroll.refresh()
      } else {
        if (!this.$refs['header-stretch']) return
        this.headerScroll = new BScroll(this.$refs['header-stretch'], {
          scrollX: true,
          probeType: 3,
          click: true
        })
        if (!this.$refs['body-stretch']) return
        this.bodyScroll = new BScroll(this.$refs['body-stretch'], {
          scrollX: true,
          eventPassthrough: 'vertical',
          probeType: 3,
          click: true
        })
        this.headerScroll.on('scroll', pos => {
          this.bodyScroll.scrollTo(pos.x, 0)
        })
        this.bodyScroll.on('scroll', pos => {
          this.headerScroll.scrollTo(pos.x, 0)
        })
      }
      // 适配左边框1px
      this.headerScroll.minScrollX = -1
      this.bodyScroll.minScrollX = -1
      this.headerScroll.scrollTo(-1, 0)
      this.bodyScroll.scrollTo(-1, 0)
      this.$emit('init-success')
    }
  }
}
</script>
<template>
  <sliding
    :show="value"
    :over-height="true"
    iconfont="icon-close_line"
    @close="$emit('input')"
  >
    <article class="scroll-table-container">
      <slot>
        <div v-if="title" class="title">
          {{ title }}
        </div>
      </slot>
      <section class="scroll-table">
        <header class="table-header">
          <div class="field">
            <div class="table-cornerstone" @touchmove.stop>
              <div class="field-atribute">
                <div class="field-atr-item">
                  年度
                </div>
                <div class="field-atr-item">
                  年龄
                </div>
              </div>
            </div>
            <div ref="header-stretch" class="table-stretch">
              <div class="table-slide">
                <div class="row">
                  <div
                    v-for="(item, index) in list"
                    :key="index"
                    class="col"
                    :style="{ width: `${itemWidth}px` }"
                    v-html="item.name"
                  />
                </div>
              </div>
            </div>
          </div>
        </header>
        <div class="table-body" :style="{ height: `${scrollHeight}px` }">
          <div class="table-cornerstone" @touchmove.stop>
            <template v-for="(item, index) in dataLenth">
              <div v-if="list[0].values[index] !== '*'" class="field-atribute">
                <div class="field-atr-item">
                  {{ index + 1 }}
                </div>
                <div class="field-atr-item">
                  {{ index + 1 + ageIndex }}
                </div>
              </div>
            </template>
          </div>
          <div ref="body-stretch" class="table-stretch">
            <div class="table-slide">
              <template v-for="(d, index) in dataLenth">
                <div v-if="list[0].values[index] !== '*'" class="row">
                  <div
                    v-for="(item, n) in list"
                    :key="`${index}-${n}`"
                    class="col"
                    :style="{ width: `${itemWidth}px` }"
                  >
                    {{ item.values[index] }}
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div v-if="fixIosWechatBar" class="table-bottom" />
        </div>
      </section>
      <slot name="footer" />
    </article>
  </sliding>
</template>
<style lang="postcss" scoped>
.scroll-table-container {
  .title {
    overflow: hidden;
    margin-bottom: -1px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 44px;
    font-size: 0.28rem;
    font-weight: bold;
    color: #000;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.scroll-table {
  user-select: none;
  touch-callout: none;
  color: #666;
  background-color: #fff;
  text-align: center;
  .table-cornerstone {
    display: table-cell;
    width: 112px;
  }
  .table-stretch {
    overflow: hidden;
    position: relative;
    display: table-cell;
    width: 100%;
    touch-action: pan-y pinch-zoom;
    -webkit-tap-highlight-color: transparent;
    .table-slide {
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      white-space: nowrap;
      .row:nth-child(2n) {
        background-color: #fdfcfa;
      }
    }
  }
  .table-bottom {
    box-sizing: content-box;
    height: 44px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.field {
  display: table;
  height: 40px;
  line-height: 40px;
  color: #6f6a67;
  background-color: #fdf8f2;
}
.field-atribute {
  display: flex;
  width: 112px;
  .field-atr-item {
    flex: 1;
    height: 40px;
    line-height: 40px;
  }
}
.table-body {
  overflow-y: auto;
  width: 100%;
  height: 300px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .table-slide {
    flex-direction: column;
  }
  &::-webkit-scrollbar {
    width: 0px;
    display: none;
  }
  .table-cornerstone {
    .field-atribute:nth-child(2n) {
      background-color: #fdfcfa;
    }
  }
}
.table-slide {
  .row {
    display: flex;
    white-space: nowrap;
  }
  .col {
    flex: 1;
    height: 40px;
    min-width: 56px;
    line-height: 40px;
  }
}
/* 线框 */
.table-header,
.table-body {
  .field-atribute {
    border-bottom: 1px solid #e5e5e5;
    .field-atr-item {
      border-right: 1px solid #e5e5e5;
    }
  }
  .table-slide {
    border-left: 1px solid #e5e5e5;
    .col {
      border-right: 1px solid #e5e5e5;
    }
  }
}
.table-header {
  .field {
    border-top: 1px solid #e5e5e5;
  }
  .table-stretch {
    .table-slide {
      z-index: 1002;
      border-bottom: 1px solid #e5e5e5;
    }
  }
}
.table-body {
  margin-top: -1px;
  .table-cornerstone,
  .table-stretch {
    border-top: 1px solid #e5e5e5;
  }
  .table-slide {
    z-index: 1001;
    .row {
      border-bottom: 1px solid #e5e5e5;
    }
  }
}
</style>
